import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientMedicareID from 'utils/print/getPatientMedicareID';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientHeightIn from 'utils/print/getPatientHeightIn';
import getPatientWeight from 'utils/print/getPatientWeight';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberFullAddress from 'utils/print/getPrescriberFullAddress';
import getPrescriberPhone1 from 'utils/print/getPrescriberPhone1';
import getPrescriberPhone2 from 'utils/print/getPrescriberPhone2';
import getPrescriberPhone3 from 'utils/print/getPrescriberPhone3';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getSupplierName from 'utils/print/getSupplierName';
import getSupplierFullAddress from 'utils/print/getSupplierFullAddress';
import getSupplierPhone1 from 'utils/print/getSupplierPhone1';
import getSupplierPhone2 from 'utils/print/getSupplierPhone2';
import getSupplierPhone3 from 'utils/print/getSupplierPhone3';
import getSupplierNSCorNPI from 'utils/print/getSupplierNSCorNPI';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineNarrativeDescriptionAndCost from 'utils/print/getOrderLineNarrativeDescriptionAndCost';
import getSignature from 'utils/print/getSignature';

const CMS484 = {
  ID: 3,
  Name: 'CMS-484 Oxygen',
  Type: 'CMS',
  Format: 'a4',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/CMS-484/1.js',
      fields: [
        {
          name: 'Certification Type/Date INITIAL 1',
          type: 'text',
          x: 90.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 2',
          type: 'text',
          x: 97.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date INITIAL 3',
          type: 'text',
          x: 104.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 1',
          type: 'text',
          x: 126.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 2',
          type: 'text',
          x: 133.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date REVISED 3',
          type: 'text',
          x: 140.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 1',
          type: 'text',
          x: 177.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 2',
          type: 'text',
          x: 184.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Certification Type/Date RECERTIFICATION 3',
          type: 'text',
          x: 191.5,
          y: 30.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 15,
          y: 40,
          width: 93,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 15,
          y: 43.25,
          width: 93,
          height: 13,
          multiline: true,
        },
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 16,
          y: 58,
          width: 11,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 29,
          y: 58,
          width: 11,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 43,
          y: 58,
          width: 15,
        },
        {
          name: 'Medicare ID',
          type: 'text',
          getValue: getPatientMedicareID,
          x: 75,
          y: 58,
          width: 33,
        },
        {
          name: 'Supplier Name and Address',
          type: 'text',
          getValue: (props) => {
            if (props.value) {
              return props.value;
            }
            return `${getSupplierName(props)}, ${getSupplierFullAddress(props)}`;
          },
          x: 113,
          y: 40,
          width: 82,
          height: 17,
          multiline: true,
        },
        {
          name: 'Supplier Phone 1',
          type: 'text',
          getValue: getSupplierPhone1,
          x: 115,
          y: 58,
          width: 11,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 2',
          type: 'text',
          getValue: getSupplierPhone2,
          x: 128,
          y: 58,
          width: 11,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Supplier Phone 3',
          type: 'text',
          getValue: getSupplierPhone3,
          x: 142,
          y: 58,
          width: 15,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Supplier NSC or NPI',
          type: 'text',
          getValue: getSupplierNSCorNPI,
          x: 177,
          y: 58,
          width: 19,
        },
        {
          name: 'Place Of Service',
          type: 'text',
          getValue: props => getOrderLinePlaceOfService({ ...props, index: 0 }),
          x: 39,
          y: 64.5,
          width: 15,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 123.5,
          y: 64.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 130,
          y: 64.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Date of Birth 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 137,
          y: 64.5,
          width: 5.5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'text',
          getValue: getPatientGender,
          x: 151,
          y: 64.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Height',
          type: 'text',
          getValue: getPatientHeightIn,
          x: 170,
          y: 64.5,
          width: 5,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Weight',
          type: 'text',
          getValue: getPatientWeight,
          x: 187,
          y: 64.5,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Supply Item/Service Procedure Code(s)',
          type: 'text',
          getValue: getOrderLineHCPCSCode,
          x: 61,
          y: 70,
          width: 48,
          height: 25.5,
          multiline: true,
        },
        {
          name: 'Prescriber Name',
          type: 'text',
          getValue: getPrescriberName,
          x: 113,
          y: 73,
          width: 82,
        },
        {
          name: 'Prescriber Email',
          type: 'text',
          getValue: getPrescriberFullAddress,
          x: 113,
          y: 76.1,
          width: 82,
          height: 13,
          multiline: true,
        },
        {
          name: 'Prescriber Phone 1',
          type: 'text',
          getValue: getPrescriberPhone1,
          x: 113,
          y: 88,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 2',
          type: 'text',
          getValue: getPrescriberPhone2,
          x: 126,
          y: 88,
          width: 10,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber Phone 3',
          type: 'text',
          getValue: getPrescriberPhone3,
          x: 141,
          y: 88,
          width: 14,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Prescriber NSC or NPI',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 178,
          y: 88,
          width: 17,
        },
        {
          name: 'EST LENGTH OF NEED',
          type: 'text',
          x: 73,
          y: 101.5,
          width: 10,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'DIAGNOSIS CODES',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 145,
          y: 101.5,
          width: 50,
        },
        {
          name: 'Enter the result of recent test taken on or before the certification date listed in Section A a)',
          type: 'text',
          x: 17,
          y: 113,
          width: 14,
          normalize: normalize.number,
        },
        {
          name: 'Enter the result of recent test taken on or before the certification date listed in Section A b)',
          type: 'text',
          x: 17,
          y: 117,
          width: 20,
          normalize: normalize.number,
        },
        {
          name: 'Enter the result of recent test taken on or before the certification date listed in Section A c) 1',
          type: 'text',
          x: 17,
          y: 121,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Enter the result of recent test taken on or before the certification date listed in Section A c) 2',
          type: 'text',
          x: 24,
          y: 121,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Enter the result of recent test taken on or before the certification date listed in Section A c) 3',
          type: 'text',
          x: 31,
          y: 121,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Was the test in Question 1 performed',
          type: 'radio',
          options: [
            {
              x: 16.3,
              y: 128.5,
              width: 2,
              height: 2,
              value: '1',
            },
            {
              x: 28,
              y: 128.5,
              width: 2,
              height: 2,
              value: '2',
            },
            {
              x: 36.5,
              y: 128.5,
              width: 2,
              height: 2,
              value: '3',
            },
          ],
        },
        {
          name: 'Check the one number for the condition of the test in Question 1',
          type: 'radio',
          options: [
            {
              x: 14.3,
              y: 141,
              width: 2,
              height: 2,
              value: '1',
            },
            {
              x: 24,
              y: 141,
              width: 2,
              height: 2,
              value: '2',
            },
            {
              x: 32.5,
              y: 141,
              width: 2,
              height: 2,
              value: '3',
            },
          ],
        },
        {
          name: 'If you are ordering portable oxygen, is the patient mobile within the home?',
          type: 'radio',
          options: [
            {
              x: 15,
              y: 151.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 25,
              y: 151.5,
              width: 2,
              height: 2,
              value: 'N',
            },
            {
              x: 33,
              y: 151.5,
              width: 2,
              height: 2,
              value: 'D',
            },
          ],
        },
        {
          name: 'Enter the highest oxygen flow rate ordered for this patient in liters per minute',
          type: 'text',
          x: 14,
          y: 160.5,
          width: 22,
        },
        {
          name: 'If greater than 4 LPM is prescribed, enter results of recent test taken on 4 LPM mm Hg',
          type: 'text',
          x: 17,
          y: 169.5,
          width: 14,
        },
        {
          name: 'If greater than 4 LPM is prescribed, enter results of recent test taken on 4 LPM %',
          type: 'text',
          x: 17,
          y: 173.5,
          width: 20,
        },
        {
          name: 'If greater than 4 LPM is prescribed, enter results of recent test taken on 4 LPM Date 1',
          type: 'text',
          x: 17,
          y: 177,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'If greater than 4 LPM is prescribed, enter results of recent test taken on 4 LPM Date 2',
          type: 'text',
          x: 24,
          y: 177,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'If greater than 4 LPM is prescribed, enter results of recent test taken on 4 LPM Date 3',
          type: 'text',
          x: 31,
          y: 177,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Does the patient have dependent edema due to congestive heart failure?',
          type: 'radio',
          options: [
            {
              x: 14.3,
              y: 190.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 190.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Does the patient have cor pulmonale or pulmonary hypertension documented by P pulmonale on an EKG or by an echocardiogram, gated blood pool scan or direct pulmonary artery pressure measurement',
          type: 'radio',
          options: [
            {
              x: 14.3,
              y: 194,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 194,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'Does the patient have a hematocrit greater than 56%?',
          type: 'radio',
          options: [
            {
              x: 14.3,
              y: 203.5,
              width: 2,
              height: 2,
              value: 'Y',
            },
            {
              x: 24,
              y: 203.5,
              width: 2,
              height: 2,
              value: 'N',
            },
          ],
        },
        {
          name: 'NAME OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 25,
          y: 212,
          width: 59,
        },
        {
          name: 'TITLE OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 95,
          y: 212,
          width: 41,
        },
        {
          name: 'EMPLOYER OF PERSON ANSWERING SECTION B QUESTIONS, IF OTHER THAN PHYSICIAN',
          type: 'text',
          x: 155,
          y: 212,
          width: 41,
        },
        {
          name: '(1) Narrative description of all items, accessories and option ordered; (2) Suppliers charge; and (3) Medicare Fee Schedule Allowance for each item, accessory, and option',
          type: 'text',
          getValue: getOrderLineNarrativeDescriptionAndCost,
          x: 14,
          y: 230,
          width: 182,
          height: 13,
          multiline: true,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 60,
          y: 259,
          width: 90,
          height: 8,
        },
        {
          name: 'Date 1',
          type: 'text',
          x: 165,
          y: 262,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          x: 175,
          y: 262,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          x: 185,
          y: 262,
          width: 8,
          maxLength: 2,
          normalize: normalize.number,
        },
      ],
    },
  ],
};

export default CMS484;



// WEBPACK FOOTER //
// ./src/config/documents/CMS-484.js